import Folder from '../store/schema/Folder';
import getRootFolderForFolderTree from './getRootFolderForFolderTree';
import { ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';

/**
 * Archive mailbox folder tree root folder selector
 */
export default function getArchiveFolderTreeRootFolder(): Folder {
    return getRootFolderForFolderTree(ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID);
}
